import { c as _c } from "react/compiler-runtime";
import type { LiveRankingItem, LiveRankingType } from '@module/apis/client-side/live/type';
import { useFetchLiveRankingInfiniteQuery } from '@module/queries/live/liveQueryHooks';
import { useIntersectionObserver } from '@module/utils/useIntersectionObserver';
const getTopScore = (item: LiveRankingItem, searchType: LiveRankingType) => {
  if (!item) return;
  if (searchType === 'rankingWatch') return item.scoreWatch;
  if (searchType === 'rankingRecom') return item.scoreLike;
  return item.scoreTotal;
};
interface Props {
  searchType: LiveRankingType;
  limitPerQuery?: number;
  errorHandler: (error: unknown) => void;
}
const useRankingViewModel = t0 => {
  const $ = _c(24);
  const {
    searchType,
    limitPerQuery: t1,
    errorHandler
  } = t0;
  const limitPerQuery = t1 === undefined ? 10 : t1;
  let t2;
  if ($[0] !== limitPerQuery || $[1] !== searchType) {
    t2 = {
      type: searchType,
      limit: limitPerQuery
    };
    $[0] = limitPerQuery;
    $[1] = searchType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    isLoading,
    data,
    hasNextPage,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
    finalParams
  } = useFetchLiveRankingInfiniteQuery(t2);
  let t3;
  if ($[3] !== fetchNextPage) {
    t3 = () => fetchNextPage();
    $[3] = fetchNextPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hasNextPage || $[6] !== isFetching) {
    t4 = () => hasNextPage && !isFetching;
    $[5] = hasNextPage;
    $[6] = isFetching;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      onInView: t3,
      isReadyToFetch: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    observerRef
  } = useIntersectionObserver(t5);
  let t6;
  if ($[11] !== errorHandler) {
    t6 = async error => {
      errorHandler(error);
    };
    $[11] = errorHandler;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleBookmarkError = t6;
  let t7;
  if ($[13] !== data || $[14] !== searchType) {
    t7 = data && getTopScore(data.pages[0], searchType);
    $[13] = data;
    $[14] = searchType;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const topScore = t7;
  let t8;
  if ($[16] !== data || $[17] !== finalParams || $[18] !== handleBookmarkError || $[19] !== isFetchingNextPage || $[20] !== isLoading || $[21] !== observerRef || $[22] !== topScore) {
    t8 = {
      isLoading,
      data,
      fetchLiveRankingParams: finalParams,
      topScore,
      observerRef,
      fetchErrorCallback: handleBookmarkError,
      isFetchingNextPage
    };
    $[16] = data;
    $[17] = finalParams;
    $[18] = handleBookmarkError;
    $[19] = isFetchingNextPage;
    $[20] = isLoading;
    $[21] = observerRef;
    $[22] = topScore;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default useRankingViewModel;